import { createContext, useContext, useState, ReactNode } from 'react'

type Breadcrumb = {
  label: string
  path?: string
  state?: any
}

type BreadcrumbsContextType = {
  breadcrumbs: Breadcrumb[]
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void
}

const BreadcrumbsContext = createContext<BreadcrumbsContextType | null>(null)

export function BreadcrumbsProvider(props: { children: ReactNode }) {
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([])

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {props.children}
    </BreadcrumbsContext.Provider>
  )
}

export function useBreadcrumbs(): [Breadcrumb[], (breadcrumbs: Breadcrumb[]) => void] {
  const context = useContext(BreadcrumbsContext)
  if (!context) {
    throw new Error('useBreadcrumbs must be used within BreadcrumbsProvider')
  }
  return [context.breadcrumbs, context.setBreadcrumbs]
}
